<template>
  <v-card>
    <v-card-title>
      <h3
        >Semi-Annual Compliance Form - Wyoming State Loan Repayment Program</h3
      >
    </v-card-title>
    <v-card-text>
      <v-flex xs12 style="text-align: left"
        >Healthcare Provider Information</v-flex
      >
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 pr-4>
          <v-text-field
            label="Name"
            :value="`${service.Application.HealthCareProvider.LastName}, ${service.Application.HealthCareProvider.FirstName}, ${service.Application.HealthCareProvider.MiddleName}`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Address"
            :value="
              service.Application.HealthCareProvider.Address.RAddressLine1
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="City, State, Zip"
            :value="`${service.Application.HealthCareProvider.Address.RCity}, ${service.Application.HealthCareProvider.Address.RState}, ${service.Application.HealthCareProvider.Address.RZip}`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Home Phone"
            :value="service.Application.HealthCareProvider.CellPhone"
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Work Phone"
            :value="service.Application.HealthCareProvider.WorkPhone"
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Work Email"
            :value="service.Application.HealthCareProvider.WorkEmail"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="License Number"
            :value="service.Application.Licensure.LicenseNumber"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="License Issue Date"
            :value="
              service.Application.Licensure.OriginalLicenseDate | formattedDate
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Current License Expiration"
            :value="
              service.Application.Licensure.LicenseExpirationDate
                | formattedDate
            "
            readonly
          ></v-text-field>
        </v-flex>
      </v-layout>
      <br />Practice Site Information
      <v-flex xs12 style="text-align: left">Practice Site Information</v-flex>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Site Name"
            :value="
              primarySiteName(service.Application.PracticeSiteInformation)
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Medical Director"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .MedicalDirectorName
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 pr-4>
          <v-text-field
            label="Site Contact"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .SiteContactNameTitle
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Address"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.Address1
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="City, State, Zip"
            :value="`${
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.City
            }, ${
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.State
            }, ${
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.Zip
            }`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Phone Number"
            :value="
              primarySite(service.Application.PracticeSiteInformation).Phone
            "
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Email for Contact"
            :value="
              primarySite(service.Application.PracticeSiteInformation).Email
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 pr-4>
          <v-text-field
            label="Date of Employment"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .EmploymentDate | formattedDate
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Hours Worked per Week"
            v-model="service.HoursWorkedWeek"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Direct Patient Care Hours per Week"
            v-model="service.HoursDirectPatientCare"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Number of Days Worked per Week"
            v-model="service.DaysWorked"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Hours Worked per Day"
            v-model="service.HoursWorkedDay"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Number of Days Absent During Reporting Period"
            v-model="service.DaysAbsent"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left">Certification</v-flex>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-card class="d-flex flex-row lg-10 justify-lg-space-around">
          I certify
          <date-picker
            label="date from"
            v-model="service.ServiceStart"
            :disabled="disabled"
            :rules="[
              rules.SCRequired(service.ServiceStart),
              rules.ServiceComplianceDateCheck(
                service.ServiceStart,
                service.ServiceEnd
              ),
            ]"
          ></date-picker>

          <date-picker
            label="date through"
            v-model="service.ServiceEnd"
            :disabled="disabled"
            :rules="[
              rules.SCRequired(service.ServiceEnd),
              rules.ServiceComplianceDateCheck(
                service.ServiceStart,
                service.ServiceEnd
              ),
            ]"
          ></date-picker>
        </v-card>
        <!-- <v-flex xs12 md12>
            <tr><td> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; I certify from  &nbsp;&nbsp;&nbsp;</td>
              <td>  <date-picker v-model="service.ServiceStart" :disabled="disabled"
            :rules="[rules.SCRequired(service.ServiceStart), rules.ServiceComplianceDateCheck(service.ServiceStart, service.ServiceEnd)]"
              ></date-picker> </td>
              <td>through &nbsp;&nbsp;&nbsp;</td>
    <td> <date-picker v-model="service.ServiceEnd" :disabled="disabled"
                :rules="[rules.SCRequired(service.ServiceEnd), rules.ServiceComplianceDateCheck(service.ServiceStart, service.ServiceEnd)]"
    ></date-picker>     </td> 
     </tr> -->
        <v-card>
          the above named healthcare provider provided services to patients at
          the practice site named above on a full-time basis. Unless indicated
          above, healthcare provider’s full-time service consisted of at least
          forty (40) hours per week for at least forty-five (45) weeks during
          the past year. The healthcare provider’s full-time service during the
          reporting period met the Wyoming State Loan Repayment Program Clinical
          Service Requirements as detailed in Attachment A, Statement of Work.
        </v-card>
        <!-- </v-flex> -->
        <v-flex xs12 v-for="a in applicantSubmittal" :key="a.ID">
          <v-layout
            row
            wrap
            v-if="
              service.Application.User.RoleID != 1 &&
              service.CurrentStatus.Status.Description != 'New'
            "
          >
            <v-flex xs12 md6 pr-4>
              <!-- v-if="isApplicant" -->
              <v-text-field
                label="Healthcare Provider"
                :value="`${a.User.FirstName} ${a.User.LastName}`"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Date"
                :value="a.ChangedOn | formattedDate"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-for="s in siteApproval" :key="s.ID">
          <v-layout
            row
            wrap
            v-if="
              service.Application.User.RoleID != 1 &&
              service.CurrentStatus.Status.Description != 'New'
            "
          >
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Site Facilitator"
                :value="`${s.User.FirstName} ${s.User.LastName}`"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Date"
                :value="s.ChangedOn | formattedDate"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-for="s in adminApproval" :key="s.ID">
          <v-layout
            row
            wrap
            v-if="
              service.Application.User.RoleID != 1 &&
              service.CurrentStatus.Status.Description != 'New'
            "
          >
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Admin"
                :value="`${s.User.FirstName} ${s.User.LastName}`"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Date"
                :value="s.ChangedOn | formattedDate"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="applicantCanSubmitComp"
        @click="verifyCompliance"
        color="primary"
        >Verify service compliance</v-btn
      >
      <v-btn
        v-if="FacilitatorCanSubmitComp"
        @click="submitCompliance"
        color="primary"
        >Submit service compliance</v-btn
      >
      <v-btn
        v-if="FacilitatorCanReSubmitComp"
        @click="ResubmitCompliance"
        color="primary"
        >ReSubmit service compliance</v-btn
      >
      <v-btn
        v-if="ApprovedServiceComp"
        @click="approveCompliance"
        color="primary"
        >Approve service compliance</v-btn
      >

      <v-btn color="secondary" @click="closeService">Close</v-btn>
      <v-btn color="primary" outline @click="print">Print</v-btn>

      <v-dialog v-model="verified" width="500">
        <v-card>
          <v-card-text>You have verified the service compliance.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="verified = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="Submit" width="500">
        <v-card>
          <v-card-text>You have submitted the service compliance.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="Submit = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="Approved" width="500">
        <v-card>
          <v-card-text>You have approved the service compliance.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="Approved = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { authComputed } from '@state/helpers'
import DatePickerVue from '../DatePicker.vue'
import Rules from '../../validation/rules'
import moment from 'moment'
import Printd from 'printd'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    service: Object,
  },
  data() {
    return {
      verified: false,
      Submit: false,
      Approved: false,
      rules: Rules,
      justify: ['space-around'],
      disabled: false,
    }
  },
  created() {},
  methods: {
    ...mapActions('errors', ['handleError']),
    print() {
      const d = new Printd()
      d.print(this.$el, [
        `.v-input {
          width: 100%;
    font-size: 16px;
    text-align: left;
}`,
        `.v-input .v-label {
    width: 50%;
}
`,
        `.v-input input {
  
  margin-left: 50%;
  width: 50%;
    max-height: 32px;
        border-style: none;
}`,
        `.v-card__actions, .v-icon {
    display: none;
}`,
      ])
    },
    primarySiteName(sites) {
      let name = ''
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          name = i.SiteAddress.SiteInsitutionName
        }
      })
      return name
    },
    primarySite(sites) {
      let site = {}
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          site = i
        }
      })
      return site
    },
    closeService() {
      this.$emit('closeService')
    },

    verifyCompliance() {
      //debugger
      axios
        .post(`ServiceCompliance/New/${this.service.ID}`, this.service)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.verified = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },
    submitCompliance() {
      axios
        .post(`ServiceCompliance/Submit/${this.service.ID}`, this.service)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.Submit = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },

    ResubmitCompliance() {
      axios
        .post(`ServiceCompliance/Submit/${this.service.ID}`, this.service)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.Submit = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },

    approveCompliance() {
      axios
        .get(`ServiceCompliance/Approve/${this.service.ID}`)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.Approved = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },
  },
  computed: {
    ...authComputed,
    applicantSubmittal() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceCompliance_Status)
      )
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'New'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },
    siteApproval() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceCompliance_Status)
      )
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'Submitted'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },
    adminApproval() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceCompliance_Status)
      )
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'Approved'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },
    canSubmit() {
      if (this.service && this.service.Application) {
        var application = this.service.Application
        //debugger
        let start
        if (this.service.ReportingTimeframe == 6) {
          start = moment(application.DateReward).add(5, 'months')
        } else if (this.service.ReportingTimeframe == 12) {
          start = moment(application.DateReward).add(11, 'months')
        } else if (this.service.ReportingTimeframe == 18) {
          start = moment(application.DateReward).add(17, 'months')
        } else if (this.service.ReportingTimeframe == 24) {
          start = moment(application.DateReward).add(23, 'months')
        }
        if (moment(new Date()) > start) {
          return true
        }
      }
      return false
    },
    canVerify() {
      return this.currentStatusUser.RoleID != 1
    },
    applicantCanSubmitComp() {
      return (
        this.isApplicant &&
        this.canSubmit &&
        this.currentStatus &&
        this.currentStatusDescription == 'New' &&
        //most recent status was not from applicant
        this.currentStatusUser.RoleID != 2
      )
    },
    FacilitatorCanSubmitComp() {
      //debugger
      return (
        this.isFacilitator &&
        this.currentStatusDescription == 'New' &&
        this.canVerify &&
        this.canSubmit
      )
    },

    FacilitatorCanReSubmitComp() {
      return (
        this.isFacilitator &&
        this.currentStatusDescription == 'Submitted' &&
        this.canSubmit
      )
    },
    ApprovedServiceComp() {
      return (
        this.isAdmin &&
        this.currentStatusDescription == 'Submitted' &&
        this.canSubmit
      )
    },
    sortedStatuses() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceCompliance_Status)
      )
      statuses.sort((a, b) => {
        return Date.parse(b.ChangedOn) - Date.parse(a.ChangedOn)
      })
      return statuses
    },
    currentStatus() {
      if (this.sortedStatuses && this.sortedStatuses.length > 0) {
        console.log(this.sortedStatuses[0])
        return this.sortedStatuses[0]
      }
      return null
    },
    currentStatusDescription() {
      if (this.currentStatus) {
        console.log(this.currentStatus.Status.Description)
        return this.currentStatus.Status.Description
      }
      return 'Not Submitted'
    },
    currentStatusUser() {
      if (this.currentStatus) {
        console.log(this.currentStatus.User)
        return this.currentStatus.User
      }
      return 'Not Submitted'
    },
  },
  components: {
    'date-picker': DatePickerVue,
  },
}
</script>

<style></style>
